import Parcelle from 'entity/Parcelle'
import useToggle from 'hooks/useToggle'
import { ReactComponent as PictoCalendrier } from 'assets/default/svg/picto_calendrier.svg'
import { MdEuroSymbol } from 'react-icons/md'
import pluralizer from 'utils/pluralizer'
import { FaChevronDown } from 'react-icons/fa'
import { Button } from 'react-bootstrap'
import cn from 'classnames'
import PictoAndTextList, {
  PictoAndTextListElement,
} from 'layouts/PictoAndTextListLayout/PictoAndTextList'
import s from '../Information.module.scss'

interface Props {
  parcelle: Parcelle
}

const InformationSimple = ({ parcelle }: Props): JSX.Element => {
  const { historique } = parcelle
  const [showDropdown, toggle] = useToggle()

  if (historique.length === 0) {
    return (
      <div className={s.informationSimple}>
        <Button variant="link">
          <span>Pas d&apos;historique de vente</span>
        </Button>
      </div>
    )
  }

  const pictoList: PictoAndTextListElement[] = []
  if (showDropdown) {
    historique.forEach((vente) => {
      pictoList.push({
        picto: <PictoCalendrier />,
        text: vente.date.toLocaleDateString(),
      })
      pictoList.push({ picto: <MdEuroSymbol />, text: `${vente.price} €` })
    })
  }

  return (
    <div className={cn(s.informationSimple, { [s.active]: showDropdown })}>
      <Button
        className={cn({ [s.active]: showDropdown })}
        variant="link"
        onClick={() => toggle()}
      >
        <span>
          {historique.length} {pluralizer('historique', historique.length)} de
          vente
        </span>
        <FaChevronDown />
      </Button>
      {showDropdown && (
        <>
          <hr />
          <PictoAndTextList list={pictoList} />
        </>
      )}
    </div>
  )
}

export default InformationSimple
